export class PaginacaoNest {
  currentPage: number | null
  lastPage: number | null
  next: number | null
  perPage: number | null
  prev: number | null
  totalRows: number | null

  constructor(obj?: any) {
    if (obj) {
      if (obj.currentPage) this.currentPage = obj.currentPage
      if (obj.lastPage) this.lastPage = obj.lastPage
      if (obj.next) this.next = obj.next
      if (obj.perPage) this.perPage = obj.perPage
      if (obj.prev) this.prev = obj.prev
      if (obj.total) this.totalRows = obj.total
    }
  }
}